'use client';

import type { FC, ReactNode } from 'react';

interface InfoRowProps {
  label: string;
  children: ReactNode;
}

export const InfoRow: FC<InfoRowProps> = ({ label, children }) => (
  <div className="flex flex-col gap-1 border-b border-slate-600 py-3 last:border-b-0">
    <span className="text-xs uppercase tracking-wide text-label-tertiary">{label}</span>
    <span className="text-sm text-white break-words">{children}</span>
  </div>
);
